module.exports = __webpack_public_path__ + "static/media/folder-exclamation.58a6a4c9.svg";